import styled from 'styled-components';
import { ErrorRed } from '../../app/theme/tokens/colors';

export const ErrorMessage = styled.p`
    color: ${ErrorRed};
    font-size: 14px;
    margin: 8px 0;
`;

export const NewVerificationMessageWasSent = (email) => `Um link de verificação foi enviado para ${email}`;
export const NewPwordRequired = `NEW_PASSWORD_REQUIRED`;
export const ShouldVerifyEmail = `Você deve confirmar seu e-mail através do código recebido`;
export const RecoveryCodeWasSent = (email) => `Um código de recuperação foi enviado para o e-mail ${email}`;
export const ShouldVerifySMS = 'Código enviado por SMS. Informe o código para continuar.';
export const ShouldVerifyEmailFMA = 'Código enviado por e-mail. Informe o código para continuar.';
